module.exports = require("@git-stack/store-mongo");